















































































































import {
  createComponent,
  reactive,
  computed,
  inject
} from "@vue/composition-api";
import {
  BaseStringInput,
  BaseEmailInput,
  BasePrimaryButton
} from "@web-components";
//eslint-disable-next-line
import { ValidationState } from "../views/types/validationState";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { PRIVACY_POLICY_LINK } from "@dcc/constants/links";

export default createComponent({
  components: {
    BaseStringInput,
    BaseEmailInput,
    BasePrimaryButton
  },
  setup(props: {}, { emit }) {
    const registerForm = inject("registerFormRef");

    const dictionary = useDictionary();
    const formState = reactive({
      email: "",
      firstName: "",
      lastName: "",
      emailValid: false,
      firstNameValid: false,
      lastNameValid: false,
      termsAndConditions: false,
      healthDataConsent: false
    });

    const isFormValid = computed(
      () =>
        formState.emailValid &&
        formState.lastNameValid &&
        formState.firstNameValid &&
        formState.termsAndConditions &&
        formState.healthDataConsent
    );

    const handleFirstNameValidation = (value: ValidationState) => {
      formState.firstNameValid = value.valid;
    };

    const handleLastNameValidation = (value: ValidationState) => {
      formState.lastNameValid = value.valid;
    };

    const handleEmailValidation = (value: ValidationState) => {
      formState.emailValid = value.valid;
    };

    const handleRegister = () => {
      emit("register", {
        firstName: formState.firstName,
        lastName: formState.lastName,
        email: formState.email
      });
    };

    return {
      formState,
      handleFirstNameValidation,
      handleLastNameValidation,
      handleEmailValidation,
      handleRegister,
      isFormValid,
      registerForm,
      ...dictionary,
      PRIVACY_POLICY_LINK
    };
  }
});
